import { render, staticRenderFns } from "./wechatMark.vue?vue&type=template&id=a4c720f8&scoped=true"
import script from "./wechatMark.vue?vue&type=script&lang=js"
export * from "./wechatMark.vue?vue&type=script&lang=js"
import style0 from "./wechatMark.vue?vue&type=style&index=0&id=a4c720f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c720f8",
  null
  
)

export default component.exports